<template>
  <section class="trade">
    <section class="trade__bg">
      <section class="trade__bg__content" />
    </section>
    <section class="trade__banner">
      <div class="trade__banner__content">
        <h4>
          Legend OTC
        </h4>
        <p>
          Our over-the-counter (OTC) trading service is trusted by <br />
          over 800 institutional clients. It sets the gold standard for <br />
          global liquidity, regulatory compliance, robust infrastructure,<br />
          and settlement efficiency.
        </p>
        <gold-button navType="innerRouter" styleType="gradient" url="/kyc">
          TRADE WITH US
        </gold-button>
      </div>
    </section>
    <section class="trade__partners">
      <section class="content">
        <h4>Trusted by 800+ institutions including</h4>
        <div class="content__partners-list">
          <div
            class="content__partners-list__item"
            v-for="(item, index) in partners"
            :key="index"
          >
            <a
              v-for="image in item.list"
              :key="image.name"
              :href="image.href"
              target="_blank"
            >
              <img :src="image.image" :alt="image.name" :title="image.name" />
            </a>
          </div>
        </div>
      </section>
    </section>
    <section class="trade__service">
      <section class="trade__service__content">
        <div class="panel">
          <h5>OTC TRADING SERVICES</h5>
          <section class="panel__list">
            <div class="item" v-for="(item, index) in serviceList" :key="index">
              <div class="item__top">
                <div
                  class="item__top__left"
                  :style="index % 2 !== 0 ? 'text-align: right' : ''"
                >
                  <h4 v-html="item.title" />
                  <p v-html="item.subTitle" />
                </div>
                <div
                  class="item__top__right"
                  :style="index % 2 !== 0 ? 'order:-1' : ''"
                >
                  <img :src="item.imgPath" :alt="item.altText" />
                </div>
              </div>
              <div
                class="item__bottom"
                v-if="item.extraDescribe"
                v-html="item.extraDescribe"
              />
              <div class="item__line" v-if="index !== serviceList.length - 1" />
            </div>
          </section>
        </div>
      </section>
    </section>

    <section class="trade__join">
      <section class="trade__join__content">
        <h4>GET STARTED TODAY</h4>
        <p>
          The leading U.S. regulated crypto trading firm trusted <br />
          by 800+ institutions
        </p>
        <gold-button navType="innerRouter" styleType="linear" url="/kyc">
          TRADE WITH US
        </gold-button>
      </section>
    </section>
  </section>
</template>

<script>
import GoldButton from "@/components/GoldButton.vue";

export default {
  name: "Trade",
  data() {
    return {
      partners: [
        {
          list: [
            // ["ByBit", "https://www.bybit.com/", "Exchanges Wallets"],
            ["Kucoin", "https://www.kucoin.com/", "Exchanges Wallets"],
            ["Gate", "https://www.gate.io/en/", "Exchanges Wallets"],
            ["Cobo Wallet", "https://cobo.com/", "Exchanges Wallets"],
            ["CyberX", "https://www.cyberx.com", "Brokers Institutions"],
            ["Deribit", "https://www.deribit.com/", "Exchanges Wallets"],
            ["Bitrue", "https://www.bitrue.com/", "Exchanges Wallets"],
            ["BitMart", "https://www.bitmart.com/", "Exchanges Wallets"],
            [
              "TokenPocket",
              "https://www.tokenpocket.pro/en",
              "Exchanges Wallets"
            ],
            ["Poolin", "https://www.poolin.com/", "Blockchain DeFi"],
            ["VeChain", "https://www.vechain.com/", "Blockchain DeFi"],
            ["IOTEX", "https://iotex.io/", "Blockchain DeFi"]
          ].map(item => {
            return {
              name: item[0],
              href: item[1],
              image: require(`@/assets/logo-partners/${item[2]}/${item[0]}.png`)
            };
          })
        }
      ],
      serviceList: [
        {
          title: "Deep Liquidity <br /> And Competitive Quotes",
          subTitle:
            "Legend Trading has its proprietary smart order routing system that allows our clients to access a huge and centralized liquidity pool that aggregates cryptocurrency liquidity globally. Many exchanges are also our direct clients  and trade with us constantly. By doing so, we can offer  competitive quotes, especially for ­block trades.",
          extraDescribe:
            "Our trade execution helps control slippages and tighten spreads significantly. By working with Legend Trading, institutional clients are able to obtain the best trade values of the crypto assets.",
          imgPath: require("@/assets/img/trading/otc-liquidity-icon.svg"),
          altText: "otc-liquidity-icon"
        },
        {
          title: "World-Class Trading Experience",
          subTitle:
            "24/7 electronic execution for major digital assets and fiat currency trading pairs. Our professional traders are responsive and ready to meet your trading needs anytime. Feel free to leverage our team's extensive expertise in cryptocurrency and financial markets.",
          extraDescribe: "",
          imgPath: require("@/assets/img/trading/otc-worldclass-icon.svg"),
          altText: "otc-worldclass-icon"
        },
        {
          title: "Highly Efficient Settlements",
          subTitle:
            "Legend Trading works closely with a large network of banks, financial institutions and crypto custodians. We are proud of our fast and automated settlements of digital assets and 7 major fiat currencies including USD, EUR, GBP, AUD, CAD, CHF and JPY.",
          extraDescribe: "",
          imgPath: require("@/assets/img/trading/otc-settlement-icon.svg"),
          altText: "otc-settlement-icon"
        }
      ]
    };
  },
  components: {
    GoldButton
  }
};
</script>

<style scoped lang="scss">
.trade {
  &__bg {
    // height: 56.3rem;
    height: 51.6875rem;
    width: 100%;
    background: colors(dark);
    position: absolute;
    top: 0;
    z-index: -1;

    &::after {
      content: "";
      width: 100%;
      height: 2.8125rem;
      pointer-events: none;
      background: url("../assets/img/shadowbg/edge.svg") no-repeat 50% 100%;
      background-size: contain;
      position: absolute;
      bottom: 0rem;
    }

    &__content {
      background: colors(dark);
      width: 100%;
      height: 100%;
      margin: 0;
      overflow: hidden;
    }
  }

  &__banner {
    width: 90rem;
    margin: auto;
    position: relative;
    // height: 45.4375rem;
    &::after {
      content: "";
      width: 39.375rem;
      height: 25rem;
      pointer-events: none;
      background: transparent url("../assets/img/trading/trade-bg.png")
        no-repeat 0 0;
      background-size: contain;
      top: 7.9375rem;
      right: 0;
      position: absolute;
    }

    &__content {
      padding: 7.9375rem 0rem 8.5625rem 3.75rem;

      h4 {
        font-size: 3.875rem;
        font-weight: 600;
        line-height: 1.32;
        font-weight: 600;
        color: colors(theme);
        margin-bottom: 1.25rem;
      }

      p {
        font-size: 1.5rem;
        line-height: 1.58;
        margin-bottom: 3.4375rem;
        color: colors(light);
      }
    }
  }

  &__service {
    width: 100%;
    background: colors(light);
    margin-bottom: 6rem;

    &__content {
      background: colors(light-gray);
      border-bottom-left-radius: 3.75rem;
      border-bottom-right-radius: 3.75rem;
      position: relative;

      .panel {
        width: 90rem;
        margin: auto;
        padding: 5rem 10rem 10.58125rem 10rem;

        &::after {
          content: "";
          background: url("../assets/img/shadowbg/glare-5.png") no-repeat 50%
            50%;
          position: absolute;
          width: 27.25625rem;
          height: 74.5rem;
          top: 0;
          right: 0;
          pointer-events: none;
          background-size: contain;
        }

        h5 {
          @include fontSize(base);

          font-weight: bold;
          text-align: center;
          color: colors(theme);
          margin-bottom: 6.375rem;
        }

        &__list {
          display: flex;
          flex-direction: column;
          align-items: center;

          .item {
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 100%;

            &__top {
              display: flex;
              flex-direction: row;
              align-items: center;
              padding: 0 2.5rem;
              width: 100%;
              justify-content: space-between;

              &__left {
                h4 {
                  @include fontSize(large);

                  color: colors(dark);
                  font-weight: bold;
                  margin-bottom: 1.25rem;
                }

                p {
                  @include fontSize(medium);

                  max-width: 600px;
                  color: colors(dark);
                  line-height: 2rem;
                  letter-spacing: -0.0125rem;
                  margin-bottom: 3.125rem;
                  text-align: left;
                }
              }

              &__right {
                width: 19.0625rem;
                text-align: center;
                img {
                  width: auto;
                  height: 14.125rem;
                }
              }
            }

            &__bottom {
              @include fontSize(small);

              width: 100%;
              background: colors(light);
              padding: 1.3125rem 2.5rem 1.3125rem 2.5rem;
              border-radius: 1.25rem;
              line-height: 1.75rem;
              color: colors(dark);
            }

            &__line {
              @include line;

              margin: 5.75rem auto 4.875rem auto;
            }
          }
        }
      }
    }
  }

  &__partners {
    position: relative;
    background: colors(light);

    &::before {
      content: "";
      background: url("../assets/img/shadowbg/glare-3.png") no-repeat 50% 50%;
      position: absolute;
      width: 27.25625rem;
      height: 74.5rem;
      top: -37.5rem;
      left: 0;
      pointer-events: none;
      background-size: contain;
    }

    .content {
      margin: auto;
      padding: 4.125rem 0rem 7.8125rem 0rem;

      h4 {
        @include fontSize(large);

        font-weight: bold;
        color: colors(dark);
        margin-bottom: 3.25rem;
        text-align: center;
      }

      &__partners-list {
        &__item {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          flex-wrap: wrap;
          margin: auto;
          width: 64rem;

          img {
            max-width: 9rem;
            margin-right: 1.25rem;
            margin-bottom: 1rem;
          }
        }
      }
    }
  }

  &__join {
    padding-bottom: 9.5rem;

    &__content {
      width: 84.4375rem;
      border-radius: 3.75rem;
      height: 24.4375rem;
      margin: auto;
      background-image: linear-gradient(258deg, #19222d 111%, #0f1317 18%);
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
      padding-top: 4.8125rem;
      text-align: center;

      h4 {
        @include fontSize(large);

        font-weight: bold;
        margin-bottom: 0.625rem;
        color: colors(light);
      }

      p {
        @include fontSize(medium);

        width: 30rem;
        margin-bottom: 2.8125rem;
        line-height: 2rem;
        letter-spacing: -0.0125rem;
        color: colors(light);
      }
    }
  }
}
</style>
